import React from "react";
import CrudModule from "@/components/admin/CrudModule";
import { formsCrud } from "@/services/formsService";

export default function AdminFormsPage() {
  return (
    <CrudModule
      title="Forms"
      description="Configurable public forms — define fields as JSON and they render automatically on the Contact page."
      crud={formsCrud}
      searchKeys={["title", "slug"]}
      columns={[
        { key: "title", label: "Form" },
        { key: "slug", label: "Slug" },
        { key: "fields", label: "Fields", render: (r) => `${(r.fields || []).length} fields` },
      ]}
      toggles={[{ key: "is_active", label: "Active" }]}
      fields={[
        { name: "title", label: "Form Title", type: "text", required: true },
        { name: "slug", label: "Slug", type: "text", required: true, hint: "e.g. membership-enquiry" },
        { name: "description", label: "Description", type: "textarea" },
        {
          name: "fields",
          label: "Fields (JSON array)",
          type: "json",
          required: true,
          hint: 'Types: text, email, tel, date, textarea, select, checkboxes (with "options", multiple values stored as array)',
        },
        { name: "is_active", label: "Active", type: "checkbox", default: true },
      ]}
    />
  );
}
